export * from '@primeuix/themes/lara/fileupload';
export { default } from '@primeuix/themes/lara/fileupload';
